import { useSyncExternalStore } from 'react';

/** Minimal external store for React with localStorage persistence. */
export function createStore<T>(initial: T, persistKey?: string) {
  let state: T = load();
  const subs = new Set<() => void>();

  function load(): T {
    if (!persistKey) return initial;
    try {
      const raw = localStorage.getItem(persistKey);
      return raw ? (JSON.parse(raw) as T) : initial;
    } catch {
      return initial;
    }
  }
  function persist() {
    if (!persistKey) return;
    try {
      if (state === undefined || state === null) localStorage.removeItem(persistKey);
      else localStorage.setItem(persistKey, JSON.stringify(state));
    } catch {
      /* private mode / quota */
    }
  }

  return {
    get: () => state,
    set: (next: T | ((prev: T) => T)) => {
      state = typeof next === 'function' ? (next as (p: T) => T)(state) : next;
      persist();
      subs.forEach((f) => f());
    },
    subscribe: (f: () => void) => {
      subs.add(f);
      return () => subs.delete(f);
    },
    use: () => useSyncExternalStore(
      (f) => {
        subs.add(f);
        return () => subs.delete(f);
      },
      () => state,
      () => state,
    ),
  };
}
